import React, { useEffect, useMemo, useState } from 'react';
import { TaskActionButtons } from '../events/event/Level';
import './TaskCard.scss';

const TaskCard = ({ event, stepRef }) => {
  const [selectedLevelId, setLevelId] = useState('All');
  // Array of event names to exclude
  const excludedEventNames = ['bridge_badges', 'stake_badges', 'action_badges','invite_badges']; // You can modify this array

  useEffect(() => {
    if (!event?.events?.length) return;
    setLevelId('All');
  }, [event?.eventNames]);

  const tasks = useMemo(() => {
    if (!event?.events?.length) return [];

    return selectedLevelId === 'All' ? event.events : event.events.filter(task => task.levelId === selectedLevelId);
  }, [event?.events, selectedLevelId]);
  return (
    <div className='levels-container'>
      <div className={`levels-text ${Object.keys(event.eventNames).slice(2).length > 2 ? 'more-tabs' : ''}`}>
        <h2>ENRICH IDENTITY</h2>
        <div className='tab-selector'>
          <button className={`tab ${selectedLevelId === 'All' ? 'selected' : ''}`} onClick={() => setLevelId('All')}>
            All
          </button>

          {Object.keys(event.eventNames)
            .filter(levelId => !excludedEventNames.includes(event?.eventNames[levelId]?.name))
            .map(levelId => (
              <button key={levelId} className={`tab ${selectedLevelId === levelId ? 'selected' : ''}`} onClick={() => setLevelId(levelId)}>
                <img src={event?.eventNames[levelId]?.logo} alt='Logo' className='task_img' />
                {event?.eventNames[levelId]?.name}
              </button>
            ))}
        </div>
      </div>

      <div className='task_card_container' ref={stepRef}>
        {tasks
          ?.filter(task => !excludedEventNames.includes(event?.eventNames[task.levelId]?.name))
          .map((task, index) => (
            <div className='each_task' key={index}>
              <div className='title'>
                <img src={event?.eventNames[task.levelId]?.logo} alt='EarnOS Logo' className='task_image' />
                {event?.eventNames[task.levelId]?.name}
              </div>
              <div className='task_content'>
                <div>{task?.name}</div>
                <TaskActionButtons task={task} />
              </div>
            </div>
          ))}
        {/* <div className='each_task last_task'>More coming soon...</div> */}
      </div>
    </div>
  );
};

export default TaskCard;
